import React from 'react';
import { Tag, Tooltip } from 'antd';
import { UserOutlined, BuildOutlined, FilterOutlined } from '@ant-design/icons';
import PropTypes from 'prop-types';

const UserInfo = ({ userInfo, lastUpdated }) => {
  if (!userInfo) return null;

  const formatLastUpdated = (timestamp) => {
    if (!timestamp) return '';
    const date = new Date(timestamp);
    return date.toLocaleTimeString('es-ES', { 
      hour: '2-digit', 
      minute: '2-digit' 
    });
  };

  const getRoleColor = (rol) => {
    switch (rol) {
      case 'superadmin':
        return 'red';
      case 'admin':
        return 'blue';
      case 'empresa':
        return 'green';
      default:
        return 'default';
    }
  };

  const getRoleLabel = (rol) => {
    switch (rol) {
      case 'superadmin':
        return 'Super Admin';
      case 'admin':
        return 'Administrador';
      case 'empresa':
        return 'Usuario Empresa';
      default:
        return rol;
    }
  };

  return (
    <div className="dashboard-user-info">
      <div className="dashboard-user-info__main">
        <div className="dashboard-user-info__role">
          <UserOutlined />
          <Tag color={getRoleColor(userInfo.rol)}>
            {getRoleLabel(userInfo.rol)}
          </Tag>
        </div>

        {userInfo.empresa && (
          <div className="dashboard-user-info__empresa">
            <BuildOutlined />
            <span>{userInfo.empresa}</span>
          </div>
        )}

        <div className="dashboard-user-info__filter">
          <FilterOutlined />
          <Tag color={userInfo.filtroAplicado === 'empresa' ? 'orange' : 'cyan'}>
            {userInfo.filtroAplicado === 'empresa' ? 'Filtro Empresa' : 'Vista Completa'}
          </Tag>
        </div>
      </div>

      {lastUpdated && (
        <Tooltip title={`Última actualización: ${new Date(lastUpdated).toLocaleString('es-ES')}`}>
          <div className="dashboard-user-info__timestamp">
            Actualizado: {formatLastUpdated(lastUpdated)}
          </div>
        </Tooltip>
      )}
    </div>
  );
};

UserInfo.propTypes = {
  userInfo: PropTypes.shape({
    rol: PropTypes.oneOf(['superadmin', 'admin', 'empresa']).isRequired,
    empresa: PropTypes.string,
    filtroAplicado: PropTypes.oneOf(['empresa', 'todos']).isRequired
  }),
  lastUpdated: PropTypes.string
};

UserInfo.defaultProps = {
  userInfo: null,
  lastUpdated: null
};

export default UserInfo;
